import __request__ from "routing/request";
export function listAssets(sort = "risk_score_normalized", page = 1, per_page = 15, query, filters, direction = "desc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEvidence(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/assets/bulk/categories_add", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAssetsByIds(ids, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/byIds", ids, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listPaginatedForEventPreview(sort = "name", page = 1, per_page = 15, direction = "asc", asset_type, JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/event_preview", JSONBody, { "page": page, "per_page": per_page, "sort": sort, "direction": direction, "asset_type": asset_type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getFilterOptions(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/filter_options", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listAssetIdsAndNames(sort = "name", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets/names", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAssetById(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/assets/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editAsset(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/assets/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteAsset(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/assets/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
